import { Colors, FlexBox } from "@brg/ui";
import { LayoutConst } from "core";
import { ProjectEditPageGrid, ProjectEditPageGridLabel, ProjectEditPageGridRow, ProjectEditPageGridStartLabel } from "shared/components/ProjectEditPageGrid";
import DateTimePicker from "react-datetime-picker";
import styled, { css } from "styled-components";
import { ProjectEditPageGridInput } from "_deziiign/books/pages/BookEdit/styles";
import { ProjectEditPageContainer } from "shared/pages/projectEdit/styles";
import { Input } from "@brg/input";

export const CompetitionEditPageGridRow = styled(ProjectEditPageGridRow) <{ isChoose?: boolean, largeOffsets?: boolean, isWinners?: boolean, largeOffset?: boolean, isLMS?: boolean }>`
  margin-top: ${({ largeOffsets }) => largeOffsets ? '32px' : '24px'} !important;

  .brg-input__indicators {
    justify-content: center;
    display: flex;
    height: 48px;
    max-height: 48px;
    .brg-input__indicator {
      padding: 0;
      height: 40px;
      max-height: 40px;
  
      svg {
        padding: 0;
      }
    }
  }

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    margin-top: ${({ largeOffsets }) => largeOffsets ? '24px' : '16px'};

    input {
      height: 40px !important;
    }

    .brg-input__indicators {
      height: 40px;
      max-height: 40px;
      .brg-input__indicator {
        height: 40px;
        max-height: 40px;
      }
    }
  
  @media (max-width: ${LayoutConst.screen.m}px) {
    margin-top: ${({ largeOffset }) => largeOffset ? '32.2px' : '24px'} !important;
    flex-direction: ${({ isCheckbox, isChoose }) => isChoose ? 'row' : isCheckbox ? 'row-reverse' : 'column'};
    align-items: ${({ isCheckbox, isChoose }) => (isCheckbox || isChoose) ? 'center' : 'flex-start'};
    justify-content: ${({ isCheckbox }) => isCheckbox ? 'flex-end' : 'flex-start'};
    row-gap: 8px;
  }
  
  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    margin-top: 16px!important;
    flex-direction: ${({ isCheckbox }) => isCheckbox ? 'row-reverse' : 'column'};
    align-items: ${({ isCheckbox }) => isCheckbox ? 'center' : 'flex-start'};

  }
`;


export const CompetitionInputError = styled.div`
  width: 100%;
  margin-top: 8px;
  font-size: 13px;
  line-height: 16px;
  color: ${Colors.redFailed};
`;

export const CompetitionFixedBlock = styled(CompetitionEditPageGridRow) <{ disableOffset?: boolean }>`
  max-width: ${LayoutConst.projectCover.l.w}px;

  ${({ disableOffset }) => disableOffset && css`
    margin-top: 0 !important;
  `};

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    max-width: ${LayoutConst.projectCover.m.w}px;
  }
`;

export const CriteriaMaxValueLabel = styled(FlexBox)`
  font-size: 15px;
  line-height: 20xp;
  color: #909090;
`;

export const CompetitionEditPageGridLabel = styled(ProjectEditPageGridLabel) <{ isAuthorSelect?: boolean, fullSize?: boolean, isLMS?: boolean, nowrap?: boolean }>`
  margin-right: 24px;
  width: 224px;
  min-width: 224px;
  padding-top: 0;
  color: ${({ theme }) => theme.competition.label.color};

  ${({ nowrap }) => nowrap && css` white-space: nowrap`};

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    margin-right: 16px;
    width: 160px;
    min-width: 160px;
    ${({ isLMS }) => isLMS ? css`
      max-width: 160px;
      font-size: 13px;
      line-height: 16px;
    ` : null};

  ${({ fullSize }) => fullSize && css`
    @media (max-width: ${LayoutConst.screen.m}px) {
      width: 100%;
      min-width: none;
    }
  `}

  @media (max-width: ${LayoutConst.screen.md}px) {
    margin-bottom: ${({ isAuthorSelect }) => isAuthorSelect ? 8 : 0}px;
  }

`
export const CompetitionEditPageGridStartLabel = styled(ProjectEditPageGridStartLabel) <{ isLMS?: boolean }>`
  margin-right: 0;
  padding-top: 0;
  width: 100%;
  height: 48px;
  margin-bottom: ${({ isLMS }) => isLMS ? 0 : 8}px;

  .date-input {
    width: 100%!important;
    max-width: 100% !important;
  }

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    height: 40px;
  }
  @media (max-width: ${LayoutConst.screen.md}px) {
    width: 100%
  }
`

export const ButtonText = styled.div`
  color: ${({ theme }) => theme.competition.input.secondText};
  font-size: 17px;
  line-height: 22px;
  font-weight: 400;
  letter-spacing: -0.02em;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 13px;
    line-height: 16px;
  }
`;

export const AddTagsWrapper = styled(FlexBox) <{ isEmpty?: boolean }>`
  width: 100%;
  height: 32px;
  border: 1px solid ${({ theme }) => theme.competition.input.checkbox.border};
  align-items: center;
  justify-content: center;
  border-radius: 3px;
  cursor: pointer;
  column-gap: 12px;
  margin-bottom: ${({ isEmpty }) => isEmpty ? '0' : '24px'};
  
  svg {
    width: 15px;
    height: 15px;
    path {
      fill: ${({ theme }) => theme.competition.input.inputText};
    }
  }

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    margin-bottom: ${({ isEmpty }) => isEmpty ? '0' : '16px'};
  }

  @media (max-width: ${LayoutConst.screen.md}px) {
    width: calc(100% - 16px);
  }
  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    width: 100%;
  }
`

export const CompetitionContentAddContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;

  .tags-wrapper-grid-block {
    max-width: 100%;
    margin-top: 16px;
    margin-left: 0;

    * {
      margin-left: 0;
    }
  }
`

export const CompetitionEditPageGrid = styled(ProjectEditPageGrid)`
  width: ${LayoutConst.projectContainer.l}px;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    width: ${LayoutConst.projectContainer.m}px;
    margin-top: 8px;
  }
  
  @media (max-width: ${LayoutConst.screen.md}px) {
    width: calc(100% - 32px);
    margin: 0px 16px 0px;
    height: auto;
  }
  
  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    width: 100%;
    margin: 0;
  }
`

//todo перевести на gap
export const CompetitionEditPageContainer = styled(ProjectEditPageContainer)`
  gap: 0;

  @media (max-width: ${LayoutConst.screen.md}px) {
    padding: 0;
    margin: 0;
  }

  input, .brg-input__control, .competition-select__control {
    height: 48px !important;
    max-height: 48px !important;
    min-height: 48px;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
      height: 40px !important;
      max-height: 40px !important;
      min-height: 40px !important;

      .brg-input__indicator, .brg-input__dropdown-indicator {
        padding: 0;
      }
    }
  }

  .competition-select__value-container {
    height: 100%:
  }

  .bilingual-container {

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
      flex-flow: column;
    }
  }
`

export const CompetitionEditPageGridInput = styled(ProjectEditPageGridInput) <{ isChoose?: boolean, isLMS?: boolean, isCheck?: boolean }>`
  .competition-select__input {
    display: none !important;
  }

  input {
    top: initial;
    bottom: initial;
  }
  
  .brg-input__control {
    background-color: ${({ theme }) => theme.competition.input.bg} !important;
    border: 1px solid ${({ theme }) => theme.competition.input.bg} !important;
    cursor: pointer;

    .brg-input__single-value, .brg-input__placeholder,
    .brg-input__placeholder:hover, .brg-input__single-value:hover {
      color: ${({ theme }) => theme.competition.input.inputText} !important;
      border: 1px solid ${({ theme }) => theme.competition.input.bg} !important;
    }
    ${({ isLMS }) => isLMS && css`
     .brg-input__single-value, .brg-input__placeholder,
      .brg-input__placeholder:hover, .brg-input__single-value:hover {
        color: ${({ theme }) => theme.competition.input.mainText} !important;
    }

  `}

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {

    }
  }

  .brg-input__menu-list {
    &::-webkit-scrollbar {
      height: 1px;
      width: 2px;
    }
    &::-webkit-scrollbar-track {
      border-radius: 10px;
      background: ${({ theme }) => theme.competition.input.bgActive} !important;
    }
    &::-webkit-scrollbar-thumb {
      background: ${({ theme }) => theme.competition.input.inputText} !important;
    }
  }

  .brg-input__menu {
    background-color: ${({ theme }) => theme.competition.input.bg} !important;

    .brg-input__option {
      cursor: pointer;
      color: ${({ theme }) => theme.competition.input.inputText} !important;
      svg {
        path {
          fill: ${({ theme }) => theme.competition.input.inputText} !important;
        }
      }
    }
    .brg-input__option--is-focused {
      background-color: ${({ theme }) => theme.competition.input.bgActive} !important;
    }
    .brg-input__option--is-focused:hover {
      background-color: ${({ theme }) => theme.competition.input.bgActive} !important;
    }
  }
  
  .brg-input__indicator {
    margin-right: 0;
    svg {
      path {
        fill: ${({ theme }) => theme.competition.input.inputText} !important;;
      }
    }
  }

  button {
    border: 1px solid ${({ theme }) => theme.competition.input.button.border};
    background-color: ${({ theme }) => theme.competition.input.button.bg};
    color: ${({ theme }) => theme.competition.input.mainText};
    border-radius: 3px;
    padding: 8px 36px;
    
    @media (max-width: ${LayoutConst.screen.m}px) {
      width: 100%;
    }
  }

  .globalTypes {
    color: ${({ theme }) => theme.competition.input.mainText} !important;
  }

 .competition-select__control {
   background-color: ${({ theme }) => theme.competition.input.bg};
   border: none;
   border-radius: 3px;
   cursor: pointer;
   height: 48px;

   @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
     height: 40px;
   }
 }
 .competition-select__menu-list {
   background-color: ${({ theme }) => theme.competition.input.bg}!important;
   color: ${({ theme }) => theme.competition.input.inputText}!important;
 }
 .competition-select__menu {
   background-color: ${({ theme }) => theme.competition.input.bg}!important;
   color: ${({ theme }) => theme.competition.input.inputText}!important;
 }
 .competition-select__option {
   background-color: ${({ theme }) => theme.competition.input.bg}!important;
   color: ${({ theme }) => theme.competition.input.inputText}!important;
   cursor: pointer!important;
 }
  .competition-select__indicator-separator {
    display: none;
  }
  .competition-select__value-container {
    padding: 2px 16px;
    height: 100%;
  }
  .competition-select__indicator {
    align-items: center;
    width: 40px;
    height: 40px;
    color: ${({ theme }) => theme.competition.secondaryText} !important;
  }
  
  input ~ .competition-checkbox {
    
    width: 24px;
    height: 24px;
    background: ${({ theme }) => theme.competition.input.checkbox.bg} !important;
    border-color: ${({ theme }) => theme.competition.input.checkbox.border} !important;
    
    svg {
      path {
        fill: ${({ theme }) => theme.competition.input.checkbox.icon};
      }
    }
  }
  
  input.competition-checkbox {
    
    width: 24px!important;
    height: 24px!important;
  }
  
  ${({ isCheckbox }) => isCheckbox && css`
    width: fit-content;
  `}

  ${({ isCheck }) => isCheck && css`
    align-items: flex-start;
    margin-top: 7px;
  `}
`

export const CustomDateTimePicker = styled(DateTimePicker) <{ isLMS?: boolean, isFormPage?: boolean }>`

  .react-calendar {
    background: ${({ theme }) => theme.competition.input.bg};
    border: none;
    .react-calendar__tile--now {
      background-color: ${({ theme }) => theme.competition.input.date.bgNow} !important;
      color: ${({ theme }) => theme.competition.input.date.colorNow} !important;
    }
    .react-calendar__tile--active {
      background-color: ${({ theme }) => theme.competition.input.date.bgActive} !important;
      color: ${({ theme }) => theme.competition.input.date.colorActive} !important;
    }
  }

  .react-calendar__year-view {
    .react-calendar__year-view__months__month {
      color: ${({ theme }) => theme.competition.secondaryText} !important;
    }
  }

  .react-datetime-picker__inputGroup {


    .react-datetime-picker__inputGroup__day,
    .react-datetime-picker__inputGroup__month,
    .react-datetime-picker__inputGroup__leadingZero,
    .react-datetime-picker__inputGroup__year,
    .react-datetime-picker__inputGroup__divider,
    .react-datetime-picker__inputGroup__hour,
    .react-datetime-picker__inputGroup__minute,
    .react-datetime-picker__inputGroup__second {
      outline: none;
      color: ${({ theme }) => {
        return theme.competition.secondaryText
    }} !important;
    }
    ${({ isLMS }) => isLMS && css`
    .react-datetime-picker__inputGroup__day,
    .react-datetime-picker__inputGroup__month,
    .react-datetime-picker__inputGroup__leadingZero,
    .react-datetime-picker__inputGroup__year,
    .react-datetime-picker__inputGroup__divider,
    .react-datetime-picker__inputGroup__hour,
    .react-datetime-picker__inputGroup__minute {
      color: #151514 !important;
    }
  `}
    ${({ isFormPage }) => isFormPage && css`
    .react-datetime-picker__inputGroup__day,
    .react-datetime-picker__inputGroup__month,
    .react-datetime-picker__inputGroup__leadingZero,
    .react-datetime-picker__inputGroup__year,
    .react-datetime-picker__inputGroup__divider,
    .react-datetime-picker__inputGroup__hour,
    .react-datetime-picker__inputGroup__minute {
      color: #151514 !important;
      font-size: 13px !important;
      line-height: 16px !important;
    }
  `}

  }
  
  .react-datetime-picker__inputGroup__input {
    color: ${({ theme }) => theme.competition.secondaryText} !important;
  }

  .react-datetime-picker__wrapper {
    border: none;
    border-radius: 3px;
    padding: 0 16px;
    background-color: ${({ theme }) => theme.competition.input.bg};
    
    svg {
      path {
        
        fill: ${({ theme }) => theme.competition.secondaryText};
      }
    }
  }
`

export const JuryPresidentDropdown = styled(Input.Dropdown)`
  width: 300px;
  
  .brg-input__menu {
    z-index: 1000 !important;
    width: 300px;
  }
  
  .brg-input__menu-portal {
    z-index: 1000 !important;
  }
  
  .brg-input__multi-value__remove {
    display: none !important;
  }
  
  .brg-input__clear-indicator {
    display: none !important;
  }
  
  .brg-input__multi-value {
    display: none !important;
  }
  
  .brg-input__value-container {
    overflow: hidden;
  }
  
  .brg-input__placeholder {
    display: block !important;
    opacity: 1 !important;
  }
`;import { Colors, FlexBox } from "@brg/ui";
import { LayoutConst } from "core";
import { ProjectEditPageGrid, ProjectEditPageGridLabel, ProjectEditPageGridRow, ProjectEditPageGridStartLabel } from "shared/components/ProjectEditPageGrid";
import DateTimePicker from "react-datetime-picker";
import styled, { css } from "styled-components";
import { ProjectEditPageGridInput } from "_deziiign/books/pages/BookEdit/styles";
import { ProjectEditPageContainer } from "shared/pages/projectEdit/styles";
import { Input } from "@brg/input";

export const CompetitionEditPageGridRow = styled(ProjectEditPageGridRow) <{ isChoose?: boolean, largeOffsets?: boolean, isWinners?: boolean, largeOffset?: boolean, isLMS?: boolean }>`
  margin-top: ${({ largeOffsets }) => largeOffsets ? '32px' : '24px'} !important;

  .brg-input__indicators {
    justify-content: center;
    display: flex;
    height: 48px;
    max-height: 48px;
    .brg-input__indicator {
      padding: 0;
      height: 40px;
      max-height: 40px;
  
      svg {
        padding: 0;
      }
    }
  }

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    margin-top: ${({ largeOffsets }) => largeOffsets ? '24px' : '16px'};

    input {
      height: 40px !important;
    }

    .brg-input__indicators {
      height: 40px;
      max-height: 40px;
      .brg-input__indicator {
        height: 40px;
        max-height: 40px;
      }
    }
  
  @media (max-width: ${LayoutConst.screen.m}px) {
    margin-top: ${({ largeOffset }) => largeOffset ? '32.2px' : '24px'} !important;
    flex-direction: ${({ isCheckbox, isChoose }) => isChoose ? 'row' : isCheckbox ? 'row-reverse' : 'column'};
    align-items: ${({ isCheckbox, isChoose }) => (isCheckbox || isChoose) ? 'center' : 'flex-start'};
    justify-content: ${({ isCheckbox }) => isCheckbox ? 'flex-end' : 'flex-start'};
    row-gap: 8px;
  }
  
  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    margin-top: 16px!important;
    flex-direction: ${({ isCheckbox }) => isCheckbox ? 'row-reverse' : 'column'};
    align-items: ${({ isCheckbox }) => isCheckbox ? 'center' : 'flex-start'};

  }
`;


export const CompetitionInputError = styled.div`
  width: 100%;
  margin-top: 8px;
  font-size: 13px;
  line-height: 16px;
  color: ${Colors.redFailed};
`;

export const CompetitionFixedBlock = styled(CompetitionEditPageGridRow) <{ disableOffset?: boolean }>`
  max-width: ${LayoutConst.projectCover.l.w}px;

  ${({ disableOffset }) => disableOffset && css`
    margin-top: 0 !important;
  `};

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    max-width: ${LayoutConst.projectCover.m.w}px;
  }
`;

export const CriteriaMaxValueLabel = styled(FlexBox)`
  font-size: 15px;
  line-height: 20xp;
  color: #909090;
`;

export const CompetitionEditPageGridLabel = styled(ProjectEditPageGridLabel) <{ isAuthorSelect?: boolean, fullSize?: boolean, isLMS?: boolean, nowrap?: boolean }>`
  margin-right: 24px;
  width: 224px;
  min-width: 224px;
  padding-top: 0;
  color: ${({ theme }) => theme.competition.label.color};

  ${({ nowrap }) => nowrap && css` white-space: nowrap`};

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    margin-right: 16px;
    width: 160px;
    min-width: 160px;
    ${({ isLMS }) => isLMS ? css`
      max-width: 160px;
      font-size: 13px;
      line-height: 16px;
    ` : null};

  ${({ fullSize }) => fullSize && css`
    @media (max-width: ${LayoutConst.screen.m}px) {
      width: 100%;
      min-width: none;
    }
  `}

  @media (max-width: ${LayoutConst.screen.md}px) {
    margin-bottom: ${({ isAuthorSelect }) => isAuthorSelect ? 8 : 0}px;
  }

`
export const CompetitionEditPageGridStartLabel = styled(ProjectEditPageGridStartLabel) <{ isLMS?: boolean }>`
  margin-right: 0;
  padding-top: 0;
  width: 100%;
  height: 48px;
  margin-bottom: ${({ isLMS }) => isLMS ? 0 : 8}px;

  .date-input {
    width: 100%!important;
    max-width: 100% !important;
  }

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    height: 40px;
  }
  @media (max-width: ${LayoutConst.screen.md}px) {
    width: 100%
  }
`

export const ButtonText = styled.div`
  color: ${({ theme }) => theme.competition.input.secondText};
  font-size: 17px;
  line-height: 22px;
  font-weight: 400;
  letter-spacing: -0.02em;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 13px;
    line-height: 16px;
  }
`;

export const AddTagsWrapper = styled(FlexBox) <{ isEmpty?: boolean }>`
  width: 100%;
  height: 32px;
  border: 1px solid ${({ theme }) => theme.competition.input.checkbox.border};
  align-items: center;
  justify-content: center;
  border-radius: 3px;
  cursor: pointer;
  column-gap: 12px;
  margin-bottom: ${({ isEmpty }) => isEmpty ? '0' : '24px'};
  
  svg {
    width: 15px;
    height: 15px;
    path {
      fill: ${({ theme }) => theme.competition.input.inputText};
    }
  }

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    margin-bottom: ${({ isEmpty }) => isEmpty ? '0' : '16px'};
  }

  @media (max-width: ${LayoutConst.screen.md}px) {
    width: calc(100% - 16px);
  }
  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    width: 100%;
  }
`

export const CompetitionContentAddContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;

  .tags-wrapper-grid-block {
    max-width: 100%;
    margin-top: 16px;
    margin-left: 0;

    * {
      margin-left: 0;
    }
  }
`

export const CompetitionEditPageGrid = styled(ProjectEditPageGrid)`
  width: ${LayoutConst.projectContainer.l}px;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    width: ${LayoutConst.projectContainer.m}px;
    margin-top: 8px;
  }
  
  @media (max-width: ${LayoutConst.screen.md}px) {
    width: calc(100% - 32px);
    margin: 0px 16px 0px;
    height: auto;
  }
  
  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    width: 100%;
    margin: 0;
  }
`

//todo перевести на gap
export const CompetitionEditPageContainer = styled(ProjectEditPageContainer)`
  gap: 0;

  @media (max-width: ${LayoutConst.screen.md}px) {
    padding: 0;
    margin: 0;
  }

  input, .brg-input__control, .competition-select__control {
    height: 48px !important;
    max-height: 48px !important;
    min-height: 48px;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
      height: 40px !important;
      max-height: 40px !important;
      min-height: 40px !important;

      .brg-input__indicator, .brg-input__dropdown-indicator {
        padding: 0;
      }
    }
  }

  .competition-select__value-container {
    height: 100%:
  }

  .bilingual-container {

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
      flex-flow: column;
    }
  }
`

export const CompetitionEditPageGridInput = styled(ProjectEditPageGridInput) <{ isChoose?: boolean, isLMS?: boolean, isCheck?: boolean }>`
  .competition-select__input {
    display: none !important;
  }

  input {
    top: initial;
    bottom: initial;
  }
  
  .brg-input__control {
    background-color: ${({ theme }) => theme.competition.input.bg} !important;
    border: 1px solid ${({ theme }) => theme.competition.input.bg} !important;
    cursor: pointer;

    .brg-input__single-value, .brg-input__placeholder,
    .brg-input__placeholder:hover, .brg-input__single-value:hover {
      color: ${({ theme }) => theme.competition.input.inputText} !important;
      border: 1px solid ${({ theme }) => theme.competition.input.bg} !important;
    }
    ${({ isLMS }) => isLMS && css`
     .brg-input__single-value, .brg-input__placeholder,
      .brg-input__placeholder:hover, .brg-input__single-value:hover {
        color: ${({ theme }) => theme.competition.input.mainText} !important;
    }

  `}

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {

    }
  }

  .brg-input__menu-list {
    &::-webkit-scrollbar {
      height: 1px;
      width: 2px;
    }
    &::-webkit-scrollbar-track {
      border-radius: 10px;
      background: ${({ theme }) => theme.competition.input.bgActive} !important;
    }
    &::-webkit-scrollbar-thumb {
      background: ${({ theme }) => theme.competition.input.inputText} !important;
    }
  }

  .brg-input__menu {
    background-color: ${({ theme }) => theme.competition.input.bg} !important;

    .brg-input__option {
      cursor: pointer;
      color: ${({ theme }) => theme.competition.input.inputText} !important;
      svg {
        path {
          fill: ${({ theme }) => theme.competition.input.inputText} !important;
        }
      }
    }
    .brg-input__option--is-focused {
      background-color: ${({ theme }) => theme.competition.input.bgActive} !important;
    }
    .brg-input__option--is-focused:hover {
      background-color: ${({ theme }) => theme.competition.input.bgActive} !important;
    }
  }
  
  .brg-input__indicator {
    margin-right: 0;
    svg {
      path {
        fill: ${({ theme }) => theme.competition.input.inputText} !important;;
      }
    }
  }

  button {
    border: 1px solid ${({ theme }) => theme.competition.input.button.border};
    background-color: ${({ theme }) => theme.competition.input.button.bg};
    color: ${({ theme }) => theme.competition.input.mainText};
    border-radius: 3px;
    padding: 8px 36px;
    
    @media (max-width: ${LayoutConst.screen.m}px) {
      width: 100%;
    }
  }

  .globalTypes {
    color: ${({ theme }) => theme.competition.input.mainText} !important;
  }

 .competition-select__control {
   background-color: ${({ theme }) => theme.competition.input.bg};
   border: none;
   border-radius: 3px;
   cursor: pointer;
   height: 48px;

   @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
     height: 40px;
   }
 }
 .competition-select__menu-list {
   background-color: ${({ theme }) => theme.competition.input.bg}!important;
   color: ${({ theme }) => theme.competition.input.inputText}!important;
 }
 .competition-select__menu {
   background-color: ${({ theme }) => theme.competition.input.bg}!important;
   color: ${({ theme }) => theme.competition.input.inputText}!important;
 }
 .competition-select__option {
   background-color: ${({ theme }) => theme.competition.input.bg}!important;
   color: ${({ theme }) => theme.competition.input.inputText}!important;
   cursor: pointer!important;
 }
  .competition-select__indicator-separator {
    display: none;
  }
  .competition-select__value-container {
    padding: 2px 16px;
    height: 100%;
  }
  .competition-select__indicator {
    align-items: center;
    width: 40px;
    height: 40px;
    color: ${({ theme }) => theme.competition.secondaryText} !important;
  }
  
  input ~ .competition-checkbox {
    
    width: 24px;
    height: 24px;
    background: ${({ theme }) => theme.competition.input.checkbox.bg} !important;
    border-color: ${({ theme }) => theme.competition.input.checkbox.border} !important;
    
    svg {
      path {
        fill: ${({ theme }) => theme.competition.input.checkbox.icon};
      }
    }
  }
  
  input.competition-checkbox {
    
    width: 24px!important;
    height: 24px!important;
  }
  
  ${({ isCheckbox }) => isCheckbox && css`
    width: fit-content;
  `}

  ${({ isCheck }) => isCheck && css`
    align-items: flex-start;
    margin-top: 7px;
  `}
`

export const CustomDateTimePicker = styled(DateTimePicker) <{ isLMS?: boolean, isFormPage?: boolean }>`

  .react-calendar {
    background: ${({ theme }) => theme.competition.input.bg};
    border: none;
    .react-calendar__tile--now {
      background-color: ${({ theme }) => theme.competition.input.date.bgNow} !important;
      color: ${({ theme }) => theme.competition.input.date.colorNow} !important;
    }
    .react-calendar__tile--active {
      background-color: ${({ theme }) => theme.competition.input.date.bgActive} !important;
      color: ${({ theme }) => theme.competition.input.date.colorActive} !important;
    }
  }

  .react-calendar__year-view {
    .react-calendar__year-view__months__month {
      color: ${({ theme }) => theme.competition.secondaryText} !important;
    }
  }

  .react-datetime-picker__inputGroup {


    .react-datetime-picker__inputGroup__day,
    .react-datetime-picker__inputGroup__month,
    .react-datetime-picker__inputGroup__leadingZero,
    .react-datetime-picker__inputGroup__year,
    .react-datetime-picker__inputGroup__divider,
    .react-datetime-picker__inputGroup__hour,
    .react-datetime-picker__inputGroup__minute,
    .react-datetime-picker__inputGroup__second {
      outline: none;
      color: ${({ theme }) => {
        return theme.competition.secondaryText
    }} !important;
    }
    ${({ isLMS }) => isLMS && css`
    .react-datetime-picker__inputGroup__day,
    .react-datetime-picker__inputGroup__month,
    .react-datetime-picker__inputGroup__leadingZero,
    .react-datetime-picker__inputGroup__year,
    .react-datetime-picker__inputGroup__divider,
    .react-datetime-picker__inputGroup__hour,
    .react-datetime-picker__inputGroup__minute {
      color: #151514 !important;
    }
  `}
    ${({ isFormPage }) => isFormPage && css`
    .react-datetime-picker__inputGroup__day,
    .react-datetime-picker__inputGroup__month,
    .react-datetime-picker__inputGroup__leadingZero,
    .react-datetime-picker__inputGroup__year,
    .react-datetime-picker__inputGroup__divider,
    .react-datetime-picker__inputGroup__hour,
    .react-datetime-picker__inputGroup__minute {
      color: #151514 !important;
      font-size: 13px !important;
      line-height: 16px !important;
    }
  `}

  }
  
  .react-datetime-picker__inputGroup__input {
    color: ${({ theme }) => theme.competition.secondaryText} !important;
  }

  .react-datetime-picker__wrapper {
    border: none;
    border-radius: 3px;
    padding: 0 16px;
    background-color: ${({ theme }) => theme.competition.input.bg};
    
    svg {
      path {
        
        fill: ${({ theme }) => theme.competition.secondaryText};
      }
    }
  }
`

export const JuryPresidentDropdown = styled(Input.Dropdown)`
  width: 300px;
  
  .brg-input__menu {
    z-index: 1000 !important;
    width: 300px;
  }
  
  .brg-input__menu-portal {
    z-index: 1000 !important;
  }
  
  .brg-input__multi-value__remove {
    display: none !important;
  }
  
  .brg-input__clear-indicator {
    display: none !important;
  }
  
  .brg-input__multi-value {
    display: none !important;
  }
  
  .brg-input__value-container {
    overflow: hidden;
  }
  
  .brg-input__placeholder {
    display: block !important;
    opacity: 1 !important;
  }
`;